import { useQuery } from 'react-query';
import { queryClient } from '../../../../../../../../config/queryClient';
import { queryKeys } from './queryKeys';

// Comparison and probability data come from mutations while what-ifs are open.
// invalidateQueries does not rerun those mutations, so apply bumps this token
// and the what-if effects depend on it.
export const bumpSocialSecurityWhatIfRefresh = (clientId: number, fpId: string) => {
  queryClient.setQueryData(queryKeys.socialSecurityWhatIfRefresh(clientId, fpId), Date.now());
};

export const useSocialSecurityWhatIfRefreshToken = (clientId: number, fpId: string) => {
  const { data } = useQuery(queryKeys.socialSecurityWhatIfRefresh(clientId, fpId), () => 0, {
    enabled: false,
    initialData: 0,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return data ?? 0;
};
